export const ADD_ITEM_TO_WISHLIST_REQUEST = 'ADD_ITEM_TO_WISHLIST_REQUEST'
export const ADD_ITEM_TO_WISHLIST_SUCCESS = 'ADD_ITEM_TO_WISHLIST_SUCCESS'
export const ADD_ITEM_TO_WISHLIST_FAILURE = 'ADD_ITEM_TO_WISHLIST_FAILURE'

export const GET_WISHLIST_REQUEST = 'GET_WISHLIST_REQUEST'
export const GET_WISHLIST_SUCCESS = 'GET_WISHLIST_SUCCESS'
export const GET_WISHLIST_FAILURE = 'GET_WISHLIST_FAILURE'

export const IS_WISHLIST_ITEM_EXIST_REQUEST = 'IS_WISHLIST_ITEM_EXIST_REQUEST'
export const IS_WISHLIST_ITEM_EXIST_SUCCESS = 'IS_WISHLIST_ITEM_EXIST_SUCCESS'
export const IS_WISHLIST_ITEM_EXIST_FAILURE = 'IS_WISHLIST_ITEM_EXIST_FAILURE'

export const REMOVE_WISHLIST_ITEM_REQUEST = 'REMOVE_WISHLIST_ITEM_REQUEST'
export const REMOVE_WISHLIST_ITEM_SUCCESS = 'REMOVE_WISHLIST_ITEM_SUCCESS'
export const REMOVE_WISHLIST_ITEM_FAILURE = 'REMOVE_WISHLIST_ITEM_FAILURE'
